import { render } from "./TestQuizNumber.vue?vue&type=template&id=765f39ca&scoped=true"
import script from "./TestQuizNumber.vue?vue&type=script&lang=js"
export * from "./TestQuizNumber.vue?vue&type=script&lang=js"

import "./TestQuizNumber.vue?vue&type=style&index=0&id=765f39ca&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765f39ca"]])

export default __exports__